import React from "react";
import CustomerSupportAside from "./CustomerSupportAside";
import { Route, Routes } from "react-router-dom";
import CustomerSupportData from "./CustomerSupportData";
import CustomerSupportCentralization from "./CustomerSupportCentralization";
import CustomerSupportFollowup from "./CustomerSupportFollowup";
import CustomerSupportChecklist from "./CustomerSupportChecklist";
import CentralizationData from "./CentralizationData";
import Centralisation from "./Centralisation";
import './customersupport.css'

const CustomerSupportExicutive = () => {

    return (
        <div className="mainBlock">
            <CustomerSupportAside />
            <h2>Customer Support Exicutive</h2>

            {/* Route Links for the tabs */}
            <Routes>
                <Route path="/C_S_Data" element={<CustomerSupportData />} />
                <Route path="/C_S_Centralization" element={<CustomerSupportCentralization />} />
                <Route path='/C_S_Followup' element={<CustomerSupportFollowup />} />
                <Route path="/C_S_checklist" element={<CustomerSupportChecklist />} />
                {/* <Route
                    path="/customer-support/centralization/:schoolId"
                    element={<CentralizationData />} />
                 */}
                <Route
                    path="/customer-support/centralization/:schoolId"
                    element={<Centralisation />} />
            </Routes>




        </div>
    )
}

export default CustomerSupportExicutive;